import React from "react";
import clsx from "clsx";
import * as styles from "./index.module.scss";
import { Link } from "@remix-run/react";

export const PrimaryButton = React.forwardRef(
  (
    {
      onClick,
      children,
      className,
      purple = false,
      as = "button",
      to,
      ...rest
    },
    ref,
  ) => {
    if (as === "a" && Boolean(to)) {
      return (
        <Link
          onClick={onClick}
          to={to}
          ref={ref}
          {...rest}
          className={clsx(styles.button, purple && styles.purple, className)}
        >
          {children}
        </Link>
      );
    }

    return (
      <button
        type="button"
        onClick={onClick}
        ref={ref}
        {...rest}
        className={clsx(styles.button, purple && styles.purple, className)}
      >
        {children}
      </button>
    );
  },
);

PrimaryButton.displayName = "PrimaryButton";
